import { RankCount } from '@/core/models/admin.model'
import { useMemo } from 'react'
import { Chart as ChartJS, Tooltip, Legend, BarElement, LogarithmicScale } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { Typography } from '@mui/material'

ChartJS.register(BarElement, Tooltip, Legend, LogarithmicScale)

export type RankCountComponentProps = {
  data: RankCount[]
  title: string
}

function RankCountComponent(props: RankCountComponentProps) {
  const { data, title } = props

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    label: false,
    scales: {
      x: {
        type: 'logarithmic' as const,
      },
    },
  }

  const datasetConsultations = useMemo(() => {
    if (data.length === 0) {
      return {
        labels: [],
        datasets: [
          {
            labels: [],
            data: [],
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(255, 159, 64, 0.2)',
            ],
          },
        ],
      }
    }
    return {
      labels: data.map((item) => {
        if (item.name != null || item.surname != null) {
          return `${item.name} ${item.surname}`
        }
        return 'User deleted'
      }),
      datasets: [
        {
          label: title,
          labels: data.map((item) => {
            if (item.name != null || item.surname != null) {
              return `${item.name} ${item.surname} (${item.email})`
            }
            return 'User deleted'
          }),
          data: data.map((data) => data.count),
        },
      ],
    }
  }, [data, title])

  return (
    <>
      <Typography variant="h2">{title}</Typography>
      <Bar data={datasetConsultations} options={options} />
    </>
  )
}

export default RankCountComponent
